import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const ControlSarampion = () => {
  return (
    <div class="listado">
        <h2 className='tituloAccion'>Control Asistencia Campaña Sarampion</h2>
        <TableContainer>
            <Table sx={{minWidth: 500}} size="small" aria-aria-label='a dense table'>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align='center'><a href='../ContAsisCamSara/MantenimientoDatos'>Mantenimiento Datos</a></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align='center'><a href='../ContAsisCamSara/IngresoUnidades'>Ingreso de Unidades</a></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align='center'><a href='../ContAsisCamSara/Listados'>Listados</a></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  )
}

export default ControlSarampion